import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, switchMap, tap } from 'rxjs/operators';
import { Organisation } from '../models/models.lib';
import { ApiService } from '../api/api.service';

const { apiUrl } = environment;

export abstract class CasiOrganisationService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  public apiService = inject(ApiService);

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<Organisation[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/organisation/all`))
      .pipe(
        map((response: any, i) => {
          return <Organisation[]>response;
        }),
        map(r => r.map(x => Organisation.create(x))),
        tap(() => (this.loading = false))
      )
    // return this.apiService.getCsrf()
    //   .pipe(
    //     switchMap((token: any) => {
    //       console.log('token: ', token);
    //     })
    //   )
    // .subscribe({
    //   next: token => {
    //     return this.http.post(encodeURI(`${apiUrl}/organisation/all`), { email })
    //       .pipe(
    //         map((response: any, i) => {
    //           return <Organisation[]>response;
    //         }),
    //         map(r => r.map(x => Organisation.create(x))),
    //         tap(() => (this.loading = false))
    //       )
    //   },
    //   error: err => {
    //     console.error(`error: `, err);
    //     return throwError(() => err);
    //   }
    // })

  }
}


@Injectable({
  providedIn: 'root'
})
export class OrganisationService extends CasiOrganisationService {

  constructor(
    http: HttpClient,
    // private apiService: ApiService
  ) {
    super(http)
  }

  get() {
    return this.apiService.getHttpCall('organisation/all', 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('organisation', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`organisation/${id}`, dataItem, 'update');
  }

}
